import React from 'react';

import { InputKeys } from '../../viewer/input-handler';

type Options = {
  /** Only fire the callback when true. Defaults to true. */
  enabled?: boolean;
  stopPropagation?: boolean;
  preventDefault?: boolean;
};

/**
 * Returns an onKeyDown handler that fires the callback when the given key is pressed.
 * @param key - The key to listen for (e.g. 'Escape', 'Enter', 'ArrowDown').
 * @param callback - Called when the key matches and enabled is true.
 * @param options - enabled, stopPropagation, preventDefault.
 */
export function useKeyHandler(
  key: InputKeys,
  callback: () => void,
  options?: Options,
): (e: React.KeyboardEvent) => void {
  const { enabled = true, stopPropagation = false, preventDefault = false } = options ?? {};

  return React.useCallback(
    (e: React.KeyboardEvent) => {
      if (!enabled || e.key !== key) {
        return;
      }
      if (stopPropagation) {
        e.stopPropagation();
      }
      if (preventDefault) {
        e.preventDefault();
      }
      callback();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [key, callback, enabled, stopPropagation, preventDefault],
  );
}
